"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CbaFullOwnerDetails = exports.CbaBasicOwnerDetails = exports.CbaAboutOwner = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultAboutOwner = require("../../../defaults/quoteTools/defaultAboutOwner");
var _cbaThemeContext = require("../cbaThemeContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable max-len */
var ownerNameInput = _defaultAboutOwner.DefaultAboutOwner.ownerNameInput,
  ownerEmailInput = _defaultAboutOwner.DefaultAboutOwner.ownerEmailInput,
  ownerBirthdateInput = _defaultAboutOwner.DefaultAboutOwner.ownerBirthdateInput,
  ownerPromoCodeInput = _defaultAboutOwner.DefaultAboutOwner.ownerPromoCodeInput,
  ownerPostCodeInput = _defaultAboutOwner.DefaultAboutOwner.ownerPostCodeInput,
  ownerTitleInput = _defaultAboutOwner.DefaultAboutOwner.ownerTitleInput,
  ownerFirstNameInput = _defaultAboutOwner.DefaultAboutOwner.ownerFirstNameInput,
  ownerLastNameInput = _defaultAboutOwner.DefaultAboutOwner.ownerLastNameInput,
  ownerMobileInput = _defaultAboutOwner.DefaultAboutOwner.ownerMobileInput,
  ownerMarketingFeedChannel = _defaultAboutOwner.DefaultAboutOwner.ownerMarketingFeedChannel;
var staffEmailValidator = function staffEmailValidator(value, watched) {
  // TODO: Remove this regx and use simple function to extract email domain.
  var matchesStaffEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(cba.com.au|bankwest.com.au)$/.test(value);
  var _watched$promotionCod = watched.promotionCode,
    promotionCode = _watched$promotionCod === void 0 ? null : _watched$promotionCod,
    _watched$promotionNo = watched.promotionNo,
    promotionNo = _watched$promotionNo === void 0 ? null : _watched$promotionNo;
  if (promotionNo > 0 && _cbaThemeContext.CBAThemeContext.promos.staffPromos.includes(promotionCode) && !matchesStaffEmail) {
    return 'The Staff Discount is only available to CBA employees. Please enter valid staff email address.';
  }
  return true;
};
var patterns = {
  ownerEmail: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  ownerMobile: /^04[0-9]{8}$/
};
var CbaAboutOwner = exports.CbaAboutOwner = _objectSpread(_objectSpread({}, _defaultAboutOwner.DefaultAboutOwner), {}, {
  showMembershipField: false,
  showCustomerSource: false,
  heading: 'Your personal information',
  showEmailDisclaimer: true,
  tncDisclaimer: /*#__PURE__*/_react["default"].createElement("span", null, "By submitting this form and providing your mobile number, you consent to receiving a phone call and SMS from us for the purpose of discussing and providing assistance with your insurance quote and you understand that if you provide an email address, it may be used by us to send you information and offers on the products and services we provide. You can opt out of receiving calls from us when we contact you or by contacting us at ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:cba@petsure.com.au"
  }, "cba@petsure.com.au"), ". You acknowledge that you have had an opportunity to review and consider the relevant Product Disclosure Statement and that your personal information is collected, used and disclosed in accordance with our Privacy Policy."),
  ownerBirthdateInput: _objectSpread(_objectSpread({}, ownerBirthdateInput), {}, {
    labelTooltip: null,
    placeholder: 'dd/mm/yyyy',
    validation: {
      required: 'Please enter your date of birth.'
    }
  }),
  ownerNameInput: _objectSpread(_objectSpread({}, ownerNameInput), {}, {
    placeholder: null
  }),
  ownerEmailInput: _objectSpread(_objectSpread({}, ownerEmailInput), {}, {
    label: 'Email (optional)',
    placeholder: null,
    validation: {
      pattern: {
        value: patterns.ownerEmail,
        message: 'Email address is invalid'
      }
    },
    crossFieldValidator: {
      fieldsToWatch: ['promotionCode', 'promotionNo'],
      validators: {
        'promotionCode': staffEmailValidator,
        'promotionNo': staffEmailValidator
      }
    }
  }),
  ownerPromoCodeInput: _objectSpread(_objectSpread({}, ownerPromoCodeInput), {}, {
    label: 'Promo code (optional)',
    placeholder: null,
    labelTooltip: 'This code may have been provided to you via email or appear on an advert',
    deps: ['owner.email']
  }),
  ownerPostCodeInput: _objectSpread(_objectSpread({}, ownerPostCodeInput), {}, {
    placeholder: null,
    labelTooltip: 'This should be your residential postcode.'
  }),
  ownerTitleInput: _objectSpread(_objectSpread({}, ownerTitleInput), {}, {
    placeholder: null
  }),
  ownerFirstNameInput: _objectSpread(_objectSpread({}, ownerFirstNameInput), {}, {
    placeholder: null
  }),
  ownerLastNameInput: _objectSpread(_objectSpread({}, ownerLastNameInput), {}, {
    placeholder: null
  }),
  ownerMobileInput: _objectSpread(_objectSpread({}, ownerMobileInput), {}, {
    placeholder: null
  }),
  ownerMarketingFeedChannel: _objectSpread(_objectSpread({}, ownerMarketingFeedChannel), {}, {
    label: 'Where did you hear about us?'
  })
});
var CbaBasicOwnerDetails = exports.CbaBasicOwnerDetails = _objectSpread({}, CbaAboutOwner);
var CbaFullOwnerDetails = exports.CbaFullOwnerDetails = _objectSpread(_objectSpread({}, CbaAboutOwner), {}, {
  ownerEmailInput: _objectSpread(_objectSpread({}, ownerEmailInput), {}, {
    label: 'Email',
    placeholder: null,
    labelTooltip: null,
    validation: {
      required: 'Please enter your email address.',
      pattern: {
        value: patterns.ownerEmail,
        message: 'Email address is invalid'
      }
    },
    crossFieldValidator: {
      fieldsToWatch: ['promotionCode', 'promotionNo'],
      validators: {
        'promotionCode': staffEmailValidator,
        'promotionNo': staffEmailValidator
      }
    }
  })
});